// AppStore.js
import createContentStore from './stores/content-store';
import createImageStore from './stores/image-store';

class AppStateStore {    
  contentStore;
  imageStore;  
  userId;

  constructor() {
    console.log("Creating AppStateStore");    
  }

  // Function to initialize stores based on uniqueId
  async initializeUserStoresAsync(uniqueId) {
    console.log(`Initializing user stores for uniqueId: ${uniqueId}`);    
    this.contentStore = await createContentStore(uniqueId);
    this.imageStore = await createImageStore(uniqueId);    
    console.log(`User stores initialized for uniqueId: ${uniqueId}`);
  }

  // Function to clear user-specific data when logging out
  async clearUserStores() {    
    await this.contentStore.deleteDatabase();
    await this.imageStore.deleteDatabase();

    // Reset the stores or perform cleanup if necessary    
    this.contentStore = null;
    this.imageStore = null;        
    console.log("User stores have been cleared.");
  }
}

const createAppStateStore = () => {
  console.log("Creating AppStateStore");
  return new AppStateStore();
};

export default createAppStateStore;
